// Preferences belong to the current site's origin, independently of the guide URL.
const key = (name: string) => `${name}:${location.host}`;
const sessionValues = new Map<string, string>();

function read(name: string): string {
  try {
    return localStorage.getItem(key(name)) || sessionValues.get(name) || '';
  } catch {
    return sessionValues.get(name) || '';
  }
}

function write(name: string, language: string): void {
  sessionValues.set(name, language);
  try {
    localStorage.setItem(key(name), language);
  } catch {
    // The current visit can still use the choice when browser storage is disabled.
  }
}

export const getSiteLanguageChoice = () => read('site-language-choice');
export const setSiteLanguageChoice = (language: string) => write('site-language-choice', language);
export const getGuideLanguageChoice = () => read('audio-guide-language');
export const setGuideLanguageChoice = (language: string) => write('audio-guide-language', language);
